import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from 'src/app/shopping-cart/shopping-cart.service';
import { AuthService } from 'src/app/_services/auth.service';

import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
	isLoggedIn$: boolean = false;
	user$ = {};

	menuBreakPoint  = 991;

	constructor(public cartService: ShoppingCartService, public authService: AuthService, public router:Router) {
	}

	ngOnInit(): void {
		console.log("NavbarComponent")
		this.authService.userData$.subscribe(res=>{
			this.user$ = res;
			if(res?.authdata) {
				this.isLoggedIn$ = true;
				setTimeout(() => {
					this.menuHoverEvent();
				}, 100);
			} else {
				this.isLoggedIn$ = false;
			}
		})


		
	}

	menuHoverEvent() {
		/****** Open menu on hover ******/
		$( '.dropdown' ).on( 'mouseenter touchstart', function( e ) {

			var _this = $( this );
				_this.siblings( '.dropdown' ).removeClass( 'open' );
				_this.parents( '.navbar-nav' ).siblings( '.navbar-nav' ).find( '.dropdown' ).removeClass( 'open' );
				_this.addClass( 'open' );
			// if ( this.getWindowWidth() > this.menuBreakPoint ) {
			// 	this.menuPosition( _this );
			// 	if( $( e.target ).siblings( '.dropdown-menu' ).length ) {
			// 		e.preventDefault();
			// 	}
			// }
	
		}).on( 'mouseleave', function( e ) {
	
			var _this = $( this );
			_this.removeClass( 'menu-left' );
			_this.removeClass( 'open' );
		});
	}

	/****** Get window width ******/
    getWindowWidth() {
        return $( window ).width();
    }

    /****** Get window height ******/
    getWindowHeight() {
        return $( window ).height();
    }
	isActive(action:string){
		return this.router.url.search(action) !==-1;
	}
}
